import React from 'react';
import IconBase from 'react-icons/IconBase';

export const TerminalIcon = props => (
  <IconBase viewBox="0 0 21 16" {...props}>
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M0 1a1 1 0 011-1h19a1 1 0 011 1v14a1 1 0 01-1 1H1a1 1 0 01-1-1V1zm6.175 4.795L3.088 2.707l1.414-1.414 3.795 3.795.707.707-.707.707-3.795 3.795-1.414-1.414 3.087-3.088zM8 11h7V9H8v2z"
      clipRule="evenodd"
    />
  </IconBase>
);
